export class InformacaoBancaria {
  public InformacaoBancariaId = '';
  public TipoConta = '';
  public Agencia = '';
  public AgenciaDigito = '';
  public Banco = '';
  public NumeroConta = '';
  public ContaDigito = '';
  public ContaBancaria = '';
}



// WEBPACK FOOTER //
// ./src/app/shared/models/informacao-bancaria.ts